import { ApolloError } from '@apollo/client';
import {
  BizOverviewOfferFragment,
  BusinessOverviewMetric,
  BusinessOverviewPeriod,
  BusinessOverviewStat,
  TeamLeadOfferScorecardRowFragment,
} from '@client/graphql/__generated__/types';
import { createContext, useContext, useState } from 'react';
import { TABS_LIST } from './constants';
import { useOrganizationPipelineQueries } from './hooks/useOrganizationPipelineQueries';

interface OrganizationPipelineContextType {
  summary: {
    data?: BusinessOverviewStat[];
    loading?: boolean;
    error?: ApolloError;
  };
  offerScorecards: {
    data?: TeamLeadOfferScorecardRowFragment[];
    loading?: boolean;
    error?: ApolloError;
    fetchTriggerRef: (ref: HTMLDivElement) => void;
  };
  businessOverviewOffers: {
    data?: BizOverviewOfferFragment[];
    loading?: boolean;
    error?: ApolloError;
    fetchTriggerRef: (ref: HTMLDivElement) => void;
  };
  selectedDateRange: BusinessOverviewPeriod;
  setSelectedDateRange: (dateRange: BusinessOverviewPeriod) => void;
  selectedTab: BusinessOverviewMetric;
  setSelectedTab: (tab: BusinessOverviewMetric) => void;
}

export const OrganizationPipelineContext =
  createContext<OrganizationPipelineContextType>(
    {} as OrganizationPipelineContextType
  );

export const OrganizationPipelineContextProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [selectedDateRange, setSelectedDateRange] =
    useState<BusinessOverviewPeriod>(BusinessOverviewPeriod.THIS_MONTH);
  const [selectedTab, setSelectedTab] = useState<BusinessOverviewMetric>(
    TABS_LIST[0]
  );

  const { summary, offerScorecards, businessOverviewOffers } =
    useOrganizationPipelineQueries({
      selectedDateRange,
      selectedTab,
    });

  return (
    <OrganizationPipelineContext.Provider
      value={{
        selectedDateRange,
        setSelectedDateRange,
        summary,
        selectedTab,
        setSelectedTab,
        offerScorecards,
        businessOverviewOffers,
      }}
    >
      {children}
    </OrganizationPipelineContext.Provider>
  );
};

export const useOrganizationPipelineContext = () => {
  return useContext(OrganizationPipelineContext);
};
